import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './LegalPages.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="back-button" onClick={() => navigate('/')}>
          <FaArrowLeft /> Volver al Inicio
        </button>

        <h1 className="legal-title">Política de Privacidad</h1>
        <p className="legal-date">Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Responsable del Tratamiento</h2>
            <p>
              <strong>Gestión Club</strong> (en adelante, "el Software" o "nosotros") es un software de gestión desarrollado
              como herramienta técnica para clubes y asociaciones cannábicas. El responsable del tratamiento de datos
              personales es cada club o asociación que utiliza nuestro software.
            </p>
            <p>
              <strong>IMPORTANTE:</strong> Como desarrolladores del software, <strong>no tenemos acceso, no almacenamos,
              no procesamos ni controlamos los datos personales</strong> de los usuarios finales (socios de los clubes).
              Cada club es el único responsable de los datos que introduce en el sistema.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Infraestructura Tecnológica</h2>
            <h3>2.1 Firebase (Google Cloud Platform)</h3>
            <p>
              Gestión Club utiliza <strong>Firebase</strong> (propiedad de Google LLC) como infraestructura de base de datos
              y autenticación. Firebase está certificado bajo:
            </p>
            <ul>
              <li><strong>ISO 27001</strong> (Gestión de Seguridad de la Información)</li>
              <li><strong>ISO 27017</strong> (Controles de Seguridad en la Nube)</li>
              <li><strong>ISO 27018</strong> (Protección de Datos Personales en la Nube)</li>
              <li><strong>SOC 2/3</strong> (Controles de Organización de Servicios)</li>
            </ul>
            <p>
              Firebase cumple con el <strong>RGPD (Reglamento General de Protección de Datos)</strong> de la Unión Europea
              y tiene servidores en la región europea para garantizar que los datos no salgan de la UE.
            </p>
            <p>
              Más información: <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                https://firebase.google.com/support/privacy
              </a>
            </p>

            <h3>2.2 Almacenamiento de Datos</h3>
            <p>Los datos se almacenan en:</p>
            <ul>
              <li><strong>Firestore Database:</strong> Base de datos principal donde se almacenan todos los datos del club
              (socios, productos, aportaciones, etc.)</li>
              <li><strong>Firebase Authentication:</strong> Sistema de autenticación de usuarios del sistema (NO socios)</li>
              <li><strong>Firebase Storage:</strong> Almacenamiento de documentos y archivos (DNI, documentos médicos, etc.)</li>
            </ul>
            <p>
              <strong>Ubicación:</strong> Los datos se almacenan en servidores de Google Cloud ubicados en la región
              <code>europe-west1</code> (Bélgica, Unión Europea), garantizando el cumplimiento del RGPD.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Datos que NO Recopilamos</h2>
            <p>Como desarrolladores del software, <strong>NO recopilamos, NO accedemos, NO procesamos</strong> ninguno de los siguientes datos:</p>
            <ul>
              <li>❌ Datos personales de socios de clubes (nombres, DNI, direcciones, teléfonos, emails)</li>
              <li>❌ Datos de ubicación de usuarios</li>
              <li>❌ Información de navegación o cookies de seguimiento</li>
              <li>❌ Información de dispositivos (IMEI, MAC, identificadores únicos)</li>
              <li>❌ Datos de pagos o transacciones financieras</li>
              <li>❌ Fotografías o documentos personales (DNI, certificados médicos)</li>
              <li>❌ Historial de consumo o actividades dentro del club</li>
              <li>❌ Datos biométricos (huellas dactilares, reconocimiento facial)</li>
            </ul>
            <p>
              Todos estos datos son <strong>propiedad exclusiva del club</strong> que utiliza el software y permanecen
              bajo su control absoluto en su instancia de Firebase.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Datos que Recopilamos (Sitio Web)</h2>
            <h3>4.1 Formulario de Contacto</h3>
            <p>
              Cuando solicitas una demo o información a través de nuestro formulario de contacto, recopilamos únicamente:
            </p>
            <ul>
              <li>Nombre completo</li>
              <li>Dirección de email</li>
              <li>Teléfono (opcional)</li>
              <li>Nombre del club (opcional)</li>
              <li>Mensaje</li>
            </ul>
            <p>
              <strong>Finalidad:</strong> Responder a tu solicitud de información y establecer comunicación comercial.
            </p>
            <p>
              <strong>Base legal:</strong> Consentimiento del interesado (Art. 6.1.a RGPD).
            </p>
            <p>
              <strong>Conservación:</strong> Hasta que solicites su eliminación o durante 2 años si no hay actividad comercial.
            </p>

            <h3>4.2 Cookies</h3>
            <p>
              Este sitio web <strong>NO utiliza cookies de seguimiento, publicidad ni analíticas</strong>.
              Solo utilizamos cookies técnicas estrictamente necesarias para el funcionamiento básico del sitio.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Responsabilidades del Club Usuario</h2>
            <p>
              Cada club o asociación que utiliza Gestión Club es el <strong>responsable del tratamiento</strong> de los datos
              personales de sus socios conforme al RGPD. El club debe:
            </p>
            <ul>
              <li>✓ Informar a sus socios sobre el tratamiento de datos (mediante política de privacidad propia)</li>
              <li>✓ Obtener el consentimiento explícito de los socios para el tratamiento de sus datos</li>
              <li>✓ Garantizar los derechos ARCO (Acceso, Rectificación, Cancelación, Oposición) de los socios</li>
              <li>✓ Implementar medidas técnicas y organizativas para proteger los datos</li>
              <li>✓ Nombrar un DPO (Delegado de Protección de Datos) si es necesario</li>
              <li>✓ Realizar evaluaciones de impacto si procede</li>
              <li>✓ Notificar brechas de seguridad a la autoridad competente</li>
            </ul>
            <p>
              <strong>Gestión Club proporciona la herramienta</strong>, pero el club es quien decide qué datos recopilar,
              cómo tratarlos y para qué fines.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Seguridad de los Datos</h2>
            <p>Gestión Club implementa las siguientes medidas de seguridad:</p>
            <ul>
              <li><strong>Encriptación en tránsito:</strong> Todas las comunicaciones usan HTTPS/TLS</li>
              <li><strong>Encriptación en reposo:</strong> Los datos en Firebase están encriptados con AES-256</li>
              <li><strong>Autenticación robusta:</strong> Sistema de autenticación Firebase con contraseñas hasheadas (bcrypt)</li>
              <li><strong>Control de acceso:</strong> Reglas de seguridad de Firestore que restringen el acceso por clubId</li>
              <li><strong>Backup automático:</strong> Firebase realiza backups automáticos diarios</li>
              <li><strong>Logs de auditoría:</strong> Registro de acciones críticas con timestamp y usuario</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Tus Derechos (Usuarios del Sitio Web)</h2>
            <p>
              Si nos has contactado a través del formulario, tienes derecho a:
            </p>
            <ul>
              <li><strong>Acceso:</strong> Saber qué datos tenemos sobre ti</li>
              <li><strong>Rectificación:</strong> Corregir datos incorrectos</li>
              <li><strong>Supresión:</strong> Solicitar la eliminación de tus datos</li>
              <li><strong>Oposición:</strong> Oponerte al tratamiento de tus datos</li>
              <li><strong>Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
              <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento</li>
            </ul>
            <p>
              Para ejercer estos derechos, contacta con nosotros en: <strong>info@gestionclub.com</strong>
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Derechos de los Socios de Clubes</h2>
            <p>
              Si eres socio de un club que utiliza Gestión Club, tus derechos ARCO deben ejercerse directamente
              ante el club, que es el responsable de tus datos. <strong>No contactes con nosotros</strong> como
              desarrolladores del software, ya que no tenemos acceso a tus datos personales.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Transferencias Internacionales</h2>
            <p>
              Los datos permanecen en servidores de la Unión Europea (región europe-west1 de Google Cloud).
              <strong>No se realizan transferencias internacionales</strong> fuera del Espacio Económico Europeo.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Modificaciones de esta Política</h2>
            <p>
              Nos reservamos el derecho a modificar esta política de privacidad. Las modificaciones se publicarán
              en esta página con la fecha de actualización correspondiente.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Contacto</h2>
            <p>
              Para cualquier consulta sobre esta política de privacidad, puedes contactarnos en:
            </p>
            <p>
              <strong>Email:</strong> info@gestionclub.com<br/>
              <strong>Ubicación:</strong> Barcelona, España
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Autoridad de Control</h2>
            <p>
              En caso de considerar que tus derechos no han sido atendidos correctamente, puedes presentar una
              reclamación ante la Agencia Española de Protección de Datos (AEPD):
            </p>
            <p>
              <strong>Web:</strong> <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a><br/>
              <strong>Sede:</strong> C/ Jorge Juan, 6, 28001 Madrid
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

